import React from "react";
import { motion } from "framer-motion";
import { profile, stats } from "../../data/portfolio";
import { Cpu, Database, Rocket, Users } from "lucide-react";

const pillars = [
  { icon: Cpu, title: "AI / GenAI", body: "LLMs, RAG, Bedrock, SageMaker, Agentic workflows in production." },
  { icon: Database, title: "Data Platforms", body: "Data Lakes, Streaming, ETL frameworks at PB / M-events scale." },
  { icon: Rocket, title: "Solutioning", body: "RFP ownership, cost models, HLD/LLD & pre-sales that win." },
  { icon: Users, title: "Delivery", body: "30+ engineer teams, architecture governance, zero-loss delivery." },
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          {/* left: title */}
          <div className="md:col-span-5">
            <div className="text-xs font-mono-display uppercase tracking-widest text-[color:var(--primary)] mb-4">
              /01 · About
            </div>
            <h2 className="font-mono-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold leading-tight">
              An architect who <span className="text-gradient-neon">codes</span>,
              <br /> a leader who <span className="text-gradient-neon">ships</span>.
            </h2>
          </div>

          {/* right: bio + pillars */}
          <div className="md:col-span-7">
            <p className="text-white/70 text-base md:text-lg font-body leading-relaxed">
              {profile.summary}
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-4">
              {pillars.map((p, i) => (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  data-testid={`about-pillar-${p.title.toLowerCase().replace(/[^a-z]/g,'-')}`}
                  className="glass rounded-2xl p-5 hover:border-[color:var(--primary)]/50 transition-all"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[color:var(--primary)]/10 text-[color:var(--primary)] mb-3">
                    <p.icon size={18} />
                  </div>
                  <div className="font-mono-display text-base text-white">{p.title}</div>
                  <p className="text-sm text-white/60 mt-1 font-body">{p.body}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        {/* stats strip */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-6 gap-6 border-t border-white/10 pt-10">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z]/g,'-')}`}
            >
              <div className="font-mono-display text-3xl md:text-4xl text-[color:var(--accent)] text-glow-lime">
                {s.prefix || ""}{s.value}{s.suffix || ""}
              </div>
              <div className="text-xs uppercase tracking-widest text-white/50 mt-1 font-mono-display">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;